module.exports = __webpack_public_path__ + "static/media/facebook-logo-charcoal.ef11cf25.svg";